export var H4 = {
  fontSize: {
    xs: '14px',
    sm: '14px',
    lg: '16px',
    xl: '18px'
  },
  lineHeight: {
    xs: '18px',
    sm: '20px',
    lg: '24px',
    xl: '28px'
  }
};